import Card from '../../../components/Card';

import Top10GoDownByStockUp from './Top10GoDownByStockUp';
import Top10GoUpByStockUp from './Top10GoUpByStockUp';

const getGoUpData = (top10GoUpData, top10GoDownData, type = 'up') => {
  let mainData = top10GoDownData;
  let subData = top10GoUpData;
  if (type === 'up') {
    mainData = top10GoUpData;
    subData = top10GoDownData;
  }

  const results = [];
  for (const item of mainData) {
    const exitItem = subData.find((t) => t.machungkhoan === item.machungkhoan);
    if (exitItem) {
      if (item.percent >= Math.abs(exitItem.value)) {
        results.push(item);
      }
    } else {
      results.push(item);
    }
  }
  return results.slice(0, 10);
};

const HighlightByStockUp = ({
  isTop10GoUpLoading,
  top10GoUpData,
  isTop10GoDownLoading,
  top10GoDownData,
  handleOpenTop10GoUpGoDownTooltip,
  isDarkMode,
  top10GoUpGoDownChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  setSelectedChartPeriod,
  handlesSelectedChartPeriodChange,
  selectedChartPeriod,
  setSelectedDataChartModal,
  setChartModalShow,
  isChartDataByCodeLoading,
}) => {
  return (
    <Card title="Highlight by Stockup.vn">
      <div className="mt-3">
        <div className="grid grid-cols-1 slg:grid-cols-2 gap-4 mt-6">
          <Top10GoUpByStockUp
            isLoading={isTop10GoUpLoading}
            data={getGoUpData(top10GoUpData, top10GoDownData)}
            isDarkMode={isDarkMode}
            handleOpenTop10GoUpGoDownTooltip={handleOpenTop10GoUpGoDownTooltip}
            top10GoUpGoDownChartData={top10GoUpGoDownChartData}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
            setSelectedChartPeriod={setSelectedChartPeriod}
            handlesSelectedChartPeriodChange={handlesSelectedChartPeriodChange}
            selectedChartPeriod={selectedChartPeriod}
            setSelectedDataChartModal={setSelectedDataChartModal}
            setChartModalShow={setChartModalShow}
            isChartDataByCodeLoading={isChartDataByCodeLoading}
          />
          <Top10GoDownByStockUp
            isLoading={isTop10GoDownLoading}
            data={getGoUpData(top10GoUpData, top10GoDownData, 'down')}
            isDarkMode={isDarkMode}
            handleOpenTop10GoUpGoDownTooltip={handleOpenTop10GoUpGoDownTooltip}
            top10GoUpGoDownChartData={top10GoUpGoDownChartData}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
            setSelectedChartPeriod={setSelectedChartPeriod}
            handlesSelectedChartPeriodChange={handlesSelectedChartPeriodChange}
            selectedChartPeriod={selectedChartPeriod}
            setSelectedDataChartModal={setSelectedDataChartModal}
            setChartModalShow={setChartModalShow}
            isChartDataByCodeLoading={isChartDataByCodeLoading}
          />
        </div>
      </div>
    </Card>
  );
};

export default HighlightByStockUp;
